<template lang="pug">
a-alert.mt-3.text-center(
  :message="$t('components.user_locked.tpl.message')"
  type="warning"
)
  template(slot="description")
    p {{ $t('components.user_locked.tpl.description_1') }}
    p
      b
        span {{ $t('components.user_locked.tpl.description_2') }}
        span(v-if="instance === 'mfar'")
          br
          span {{ $t('components.user_locked.tpl.description_3') }} (
          a(href="mailto:cau@mfar.net") cau@mfar.net
          span )
        span  {{ $t('components.user_locked.tpl.description_4') }}
</template>

<script>
import { mapState } from 'vuex';

import CauLink from '@/components/CauLink';

export default {
  components: {
    CauLink,
  },
  computed: {
    ...mapState('login', [
      'instance',
    ]),
  },
  created() {
    // digest query params
    this.$router.replace({
      name: 'locked',
    });
  },
};
</script>
